export const ROUTES = {
  home: {
    path: "/",
    title: "Home",
  },
  work: {
    path: "#work",
    title: "Work",
  },
  about: {
    path: "#about",
    title: "About",
  },
  contact: {
    path: "#contact",
    title: "Contact",
  },
  project: {
    path: "/projects/:slug",
    title: "Project",
  },
  notFound: {
    path: "/404",
    title: "Not Found",
  },
};
